import { Grid, Rating, Box, ThemeProvider } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";

import StarIcon from "@mui/icons-material/Star";
import { Controller } from "react-hook-form";

import { createTheme } from '@mui/material/styles';
import '@fontsource/prompt';


const theme = createTheme({
  typography: {
    fontFamily: 'Prompt, sans-serif',
    fontWeightBold: 600,
    fontWeightLight: 300,
  },
});

const RatingLabel = ({ label, id, hookForm, viewonly }) => {

  return (
    <ThemeProvider theme={theme}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}
        >
          <Typography variant="subtitle2">{id}. {label}</Typography>
        </Grid>
        <Grid item xs={4} md={4}>
          <HoverRating hookForm={hookForm} id={id} viewonly={viewonly} />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default RatingLabel;

const labels = {
  1: "ปรับปรุง",

  2: "น้อย",

  3: "พอใช้",

  4: "ดี",

  5: "ดีมาก",
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}

function HoverRating({ hookForm, id, viewonly }) {
  const { control } = hookForm;
  //   const [pointValue, setPointValue] = React.useState(0);
  const [hover, setHover] = React.useState(-1);

  return (
    <Controller
      name={`list_${id}`}
      control={control}
      defaultValue={0}
      render={({ field }) => {
        return (
          <Box
            sx={{
              width: 220,
              display: "flex",
              justifyContent: "start",
              alignItems: "center", // Centers items across the line (vertically)
            }}
          >
            <Rating
              size="large"
              name="hover-feedback"
              value={field.value}
              getLabelText={getLabelText}
              disabled={viewonly}
              onChange={(event, newValue) => {
                // setPointValue(newValue);
                // setValue(`list-${id}`, newValue);
                field.onChange(newValue);
              }}
              onChangeActive={(event, newHover) => {
                setHover(newHover);
              }}
              emptyIcon={
                <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
              }
            />
            {field.value !== null && (
              <Box sx={{ ml: 2 }}>
                {labels[hover !== -1 ? hover : field.value]}
              </Box>
            )}
          </Box>
        );
      }}
    />
  );
}
